module.exports = __webpack_public_path__ + "static/media/screenshot_full.0e64aec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot_full.png
// module id = 215
// module chunks = 0